import { render, staticRenderFns } from "./ChipNew.vue?vue&type=template&id=c4aa3b9e&"
import script from "./ChipNew.vue?vue&type=script&lang=js&"
export * from "./ChipNew.vue?vue&type=script&lang=js&"
import style0 from "./ChipNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports